import { Component } from '@angular/core';
import { OfflineStateService } from '../services/offline-state.service';

/**
 * Reddish diagonal-hatch overlay shown over a chart's plot area while the device was offline at
 * the scrubbed tick. Drop `<app-offline-hatch>` as a sibling of a plot div inside a
 * position:relative container. Self-contained — reads the shared offline state directly.
 */
@Component({
  selector: 'app-offline-hatch',
  template: `<div class="offline-hatch" *ngIf="offlineState.isOfflineAtTick$ | async"></div>`,
  styles: [`
    :host {
      position: absolute; inset: 0;
      pointer-events: none; z-index: 5;
    }
    .offline-hatch {
      position: absolute; inset: 0;
      pointer-events: none;
      /* Manifest: 45deg RISING lines, #D60000 pen at 3px on a 12px tile, 0.5
         opacity. The previous 10px-on-20px at 0.16 alpha read as a pink wash
         rather than the desktop's distinct diagonal rules. */
      background: repeating-linear-gradient(
        45deg,
        rgba(214, 0, 0, 0.5) 0, rgba(214, 0, 0, 0.5) 3px,
        rgba(214, 0, 0, 0) 3px, rgba(214, 0, 0, 0) 12px);
    }
  `],
})
export class OfflineHatchComponent {
  constructor(public offlineState: OfflineStateService) {}
}
